import {EnvironmentImageRequestParams} from "../../../models/image/environment-image-request-params";

export class SponsoredTopScorerSelectedImageRequestParams extends EnvironmentImageRequestParams {
  constructor(width: Number, height: Number) {
    super({width, height});

    this._resourceName = `/assets/Top_Scorer_Selected`;
    this.ratio = 3;
  }
}
